import { render, staticRenderFns } from "./ServeSale202301.vue?vue&type=template&id=ad3c32de&scoped=true"
import script from "./ServeSale202301.vue?vue&type=script&lang=js"
export * from "./ServeSale202301.vue?vue&type=script&lang=js"
import style0 from "./ServeSale202301.vue?vue&type=style&index=0&id=ad3c32de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c32de",
  null
  
)

export default component.exports